import AutocompleteField from 'components/forms/fields/autocomplete-field/autocomplete-field.component';
import { useCountries, UseCountriesOptions } from 'hooks/iso-3166.hooks';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AutocompleteBaseProps } from '../autocomplete-field/autocomplete-base/autocomplete-base.component';

export type CountryFieldProps = {
  name?: string;
  label?: string;
  'data-testid'?: string;
  idKey?: 'iso' | 'iso3' | 'numeric' | 'name';
} & UseCountriesOptions &
  Partial<AutocompleteBaseProps>;

const CountryField = ({
  name = 'country',
  label,
  'data-testid': dataTestId = 'CountryField',
  include,
  exclude,
  idKey = 'iso',
  ...rest
}: CountryFieldProps) => {
  const { t } = useTranslation();
  const countries = useCountries({ include, exclude });
  const options = useMemo(
    () =>
      countries.map(country => ({
        id: country[idKey],
        label: country.name,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [countries],
  );
  const finalLabel = useMemo(
    () => label ?? t('forms.fields.country.label'),
    [label, t],
  );

  return (
    <AutocompleteField
      name={name}
      options={options}
      label={finalLabel}
      data-testid={dataTestId}
      {...rest}
    />
  );
};

export default React.memo(CountryField);
